import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { apiGetJson } from "@/lib/sm-api";
import { AdminNichePlanFeaturesPanel } from "@/components/admin/AdminNichePlanFeaturesPanel";
import type { MatrixPlan } from "@/components/admin/AdminPlansMatrixPanel";

interface PlanLimits {
  products: number | null;
  ordersPerMonth: number | null;
  locations: number | null;
  categories: number | null;
  brands: number | null;
  b2bUsers: number | null;
  teamMembers: number | null;
  images: number | null;
  emailsPerDay: number | null;
  pushPerDay: number | null;
  calendarSync: number | null;
  storefront: boolean;
  portalB2b: boolean;
  variantsAddons: boolean;
  customerAccounts: boolean;
  loyaltyPoints: boolean;
  giftCards: boolean;
}

interface Plan extends MatrixPlan {
  limits: PlanLimits & MatrixPlan["limits"];
}

export function AdminPlansCatalogPanel() {
  const [plans, setPlans] = useState<Plan[]>([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const p = await apiGetJson<{ plans: Plan[] }>("/api/admin/plans");
      setPlans(p.plans);
    } catch (e) {
      toast.error(e instanceof Error ? e.message : "Error al cargar");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  if (loading) {
    return (
      <div className="flex items-center gap-2 p-6 text-muted-foreground">
        <Loader2 className="h-4 w-4 animate-spin" /> Cargando planes…
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6">
      <div className="rounded-lg border border-amber-500/20 bg-amber-500/5 px-3 py-2 text-[11.5px] text-muted-foreground">
        <span className="font-semibold text-foreground">Edición solo por nicho</span>{" "}
        (tabla <code className="text-[10px]">sm_niche_plan_marketing</code>). Editá precio visible,
        features destacadas y <code className="text-[10px]">limits_override</code> por rubro — se
        aplican en runtime al resolver límites del tenant. Los entitlements base en{" "}
        <code className="text-[10px]">sm_plans</code> ({plans.length} planes) siguen activos en
        billing/runtime; no se editan desde este panel.
      </div>
      <AdminNichePlanFeaturesPanel />
    </div>
  );
}
